import { render, staticRenderFns } from "./VehicleLogInformation.vue?vue&type=template&id=5a0e2149&scoped=true&"
import script from "./VehicleLogInformation.vue?vue&type=script&lang=js&"
export * from "./VehicleLogInformation.vue?vue&type=script&lang=js&"
import style0 from "./VehicleLogInformation.vue?vue&type=style&index=0&id=5a0e2149&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0e2149",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VDivider,VFadeTransition,VHover,VIcon,VRow,VSpacer})
